module.exports = __webpack_public_path__ + "static/img/rocket.b4878de0.png";